import { Component, OnInit } from '@angular/core';

import { ToastMessage } from '@shared/models/toast-message.module';
import { ToastService } from '@shared/services/toast.service';

@Component({
    selector: 'fc-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: false
})
export class ToastComponent implements OnInit {
  messages: ToastMessage[] = [];

  constructor(readonly ts: ToastService) {}

  ngOnInit() {
    this.messages = this.ts.getMessages();
  }

  deleteMsg(timeStamp: number) {
    this.ts.removeMessage(timeStamp);
  }
}
